/**
 * 系统管理员路由保护组件
 * 只有系统管理员可以访问
 */
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Spin, message } from 'antd';
import { isSystemAdmin } from '../utils/knowledgeLotteryAuth';

const SystemAdminRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [hasPermission, setHasPermission] = useState(false);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        const admin = await isSystemAdmin();
        setHasPermission(admin);
        if (!admin) {
          message.warning('只有系统管理员可以查看用户行为统计');
        }
      } catch (error) {
        console.error('权限检查失败:', error);
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Spin size="large" tip="检查权限中..." />
      </div>
    );
  }

  if (!hasPermission) {
    return <Navigate to="/knowledge-lottery" replace />;
  }

  return children;
};

export default SystemAdminRoute;
